module.exports = __webpack_public_path__ + "hubspot-2-555b8a92eeb9dd2550cc51b21998335a.webp";